import { useState } from "react";
import { Button, Collapse, Dialog, Divider, useTheme } from "@mui/material";
import { DialogActions, FormattedDialogTitle, IconDialogContent } from "../components/dialogs";
import { defineMessage, FormattedMessage } from "react-intl";
import { InfoIcon } from "./icons";
import { BackendError } from "../types";

export type Props = {
    backendError: BackendError;
};

export default (props: Props) => {
    const [showDetails, setShowDetails] = useState(false);

    const show = props.backendError !== null;

    return (
        <Dialog open={show}>
            <FormattedDialogTitle id={defineMessage({ id: "backendError.title", defaultMessage: "Backend error!" })} />
            <IconDialogContent icon="exclamation-triangle" iconColor={useTheme().palette.secondary.main}>
                {/* eslint-disable-next-line formatjs/enforce-id */}
                <FormattedMessage id={`backendError.codes.${props.backendError?.code}`} />
                {Boolean(props.backendError?.details) && (
                    <>
                        <InfoIcon
                            fixedWidth
                            onClick={() => setShowDetails(!showDetails)}
                            style={{ marginLeft: "0.3em", cursor: "pointer" }}
                        />
                        <Collapse in={showDetails}>
                            <Divider style={{ margin: "0.5em 0" }} />
                            <pre
                                style={{
                                    maxWidth: 400,
                                    whiteSpace: "pre-wrap",
                                    overflowWrap: "break-word",
                                }}
                            >
                                {props.backendError?.details}
                            </pre>
                        </Collapse>
                    </>
                )}
            </IconDialogContent>
            <DialogActions>
                <Button onClick={() => window.location.reload()} variant="text">
                    <FormattedMessage id="backendError.reload" defaultMessage="Reload the page" />
                </Button>
            </DialogActions>
        </Dialog>
    );
};
